module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "partners"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-layout"
  }, [_vm._l((_vm.partners), function(partner) {
    return (partner.name === 'Samlino (billede)') ? _c('div', {
      key: partner.name,
      staticClass: "column column__xs single-partner",
      on: {
        "click": function($event) {
          return _vm.goToInsurancePartner(partner.name)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": partner.image
      }
    })]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.partners), function(partner) {
    return (partner.name !== 'Samlino (billede)') ? _c('div', {
      key: partner.name,
      staticClass: "column column__xs single-partner",
      on: {
        "click": function($event) {
          return _vm.goToPartner(partner.name, partner.link)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": partner.image
      }
    })]) : _vm._e()
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "large-title"
  }, [_vm._v("\n            Partneraftaler\n            "), _c('p', [_vm._v("\n                Vores samarbejdspartnere tilbyder lige nu følgende kampagner:\n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31f01bfc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/search/components/partners.vue
// module id = 348
// module chunks = 1